import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FilterListOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"filter_list_off"}/>
}
